import { useState } from "react";
import { Storey } from "../interface/building/storey";

export interface StoreyStatus {
    storeys: Storey[]
    setStoreys: (storeys: Storey[]) => void

    currentStorey: Storey
    setCurrentStorey: (storey: Storey) => void

    autoGroupStorey: boolean
    setAutoGroupStorey: (value: boolean) => void
}

export function useStoreyService() {
    const [storeys, setStoreys] = useState<Storey[]>([]);
    const [currentStorey, setCurrentStorey] = useState<Storey>(null);
    const [autoGroupStorey, setAutoGroupStorey] = useState<boolean>(false); // 自动编楼层组

    return {
        storeys, setStoreys,
        currentStorey, setCurrentStorey,
        autoGroupStorey, setAutoGroupStorey,
    }
}